import { createLogger } from '@svenskaspelab/nova-core/log';
import Rest from '@svenskaspelab/ui/react/icons/Rest';

import { dialogTags } from '../../../constants.js';

const logger = createLogger('realtime-messages:session-end:inactivity-message');

export default function inactivityMessage(onAcknowledge: () => void, onLogout: () => void) {
  return {
    icon: <Rest />,
    title: 'Är du kvar?',
    tag: dialogTags.INACTIVITY,
    description: (
      <div className="text-center">
        <p>Du kommer snart bli utloggad på grund av inaktivitet.</p>
      </div>
    ),
    buttons: {
      primary: {
        label: 'Stanna kvar',
        action: () => {
          void onAcknowledge();
          logger.info('User prolonged session after inactivity warning');
        },
      },
      secondary: {
        label: 'Logga ut',
        action: () => {
          logger.info('User ended session');
          void onLogout();
        },
      },
    },
  };
}
